export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q01_b.5e5571c7.png";